import { FilterContext } from "~/providers/FilterProvider";
import type { ComponentProps } from "@ts/components";
import { SearchResultSwatch } from "@ts/search";
import React, { useContext, type FC } from "react";

type FilterSectionRangeProps = ComponentProps & {
  handle: string;
  options: SearchResultSwatch[];
  handleChange: (key: string) => void;
  value?: Record<string, any> | string;
  handleScroll: () => void;
};

export const withFilterSectionRange =
  (Component: FC<FilterSectionRangeProps>) =>
  ({
    name = "FilterRange",
    handleChange,
    ...rest
  }: FilterSectionRangeProps) => {
    const { handleScroll } = useContext(FilterContext);
    const onChange = (key: string) => () => {
      handleChange(key);
    };

    Component.displayName = name;
    return (
      <Component
        {...rest}
        handleChange={onChange}
        handleScroll={handleScroll}
      />
    );
  };
